import { ceilPrice } from "@/utils/ceilPrice";
import numberToLocalString from "@/utils/numberToLocalString";
import { Box, Flex } from "@chakra-ui/layout";
import { Button } from "@chakra-ui/react";
import styled from "@emotion/styled";
import {
  ColorIcon,
  colors,
  customEvent,
  HStack,
  LargeButton,
  LARGEL_BUTTON_TYPE,
  NextLink,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import ParlorCallButtons from "./ParlorCallButtons";

export interface DetailTitleProps {
  parlorId: number;
  name: string;
  sum: number;
}

function DetailTitle({ parlorId, name, sum }: DetailTitleProps) {
  const router = useRouter();
  return (
    <DetailTitleRoot>
      <VStack position="relative" height="60px">
        <VStack position="absolute" zIndex={2}>
          <div className="subtitle_21_b orange650">{name}</div>
          <div className="subtitle_21_b gray900">상세 예상 비용 & 할인 안내</div>
        </VStack>
        <Box
          width="220px"
          height="11px"
          position="absolute"
          bottom={0}
          background={colors.orange500}
        />
      </VStack>
      <ParlorCallButtons companyName={name} parlorId={parlorId} />
      <Box width="100%" mt="30px">
        <LargeButton
          buttonType={LARGEL_BUTTON_TYPE.ORANGE}
          onClick={() => {
            router.push("/funeral-prepare/funeral-cost/");
            customEvent({
              newGtm: { path: "parlor_detail_price", trigger_and_target: "uv_funeral_cost" },
            });
          }}
          height={44}
        >
          <HStack className="button_14_sb">
            <span>장례식장에서는 알려주지 않는 비용 줄이는 법</span>
            <ColorIcon name="arrow_right_small" color={colors.white} size={14} />
          </HStack>
        </LargeButton>
      </Box>
      <VStack background={colors.gray50} padding="20px 0" margin="30px 0" gap="10px">
        <Flex
          width="100%"
          background={colors.gray50}
          alignItems="center"
          justifyContent="center"
          margin="20px 0 20px"
          borderRadius="5px"
          gap={20}
        >
          <div className="subtitle_16_m gray700">예상 비용</div>
          <div className="subtitle_18_b">{numberToLocalString(ceilPrice(sum, 100000))}원</div>
        </Flex>
        <HStack alignItems="center" justifyContent="center" gap={10} padding="0 12px">
          <Button
            backgroundColor={colors.gray900}
            height="48px"
            padding="16px 20px"
            onClick={() => {
              customEvent({
                newGtm: { path: "parlor_detail_price", trigger_and_target: "CTA" },
              });
              customEvent({
                newGtm: {
                  path: "parlor_detail_price",
                  trigger_and_target: "CTA-uv_match_request",
                },
              });
              router.push(`/match/request/`);
            }}
          >
            <HStack gap={10}>
              <span className="button_14_sb white">전체 비용 알아보기</span>
              <ColorIcon name="icon-arrow-right-circle-mono" color={colors.white} size={16} />
            </HStack>
          </Button>
        </HStack>
      </VStack>
      <div className="caption_11_b gray600">
        안내된 예상 비용은 고이장례연구소에서 2023년 기준으로 필수 시설 이용료, 음식 비용을 추산한
        비용입니다. 관, 수의, 운구차량, 인력 등 비용은 포함되지 않았습니다.{" "}
        <u
          onClick={() => {
            router.push("/funeral-prepare/funeral-cost/");
            customEvent({
              newGtm: { path: "parlor_detail_price", trigger_and_target: "uv_funeral_cost" },
            });
          }}
        >
          더 알아보기
        </u>
      </div>

      <HStack gap={4} alignItems="center" justifyContent="center" padding="16px 0 16px">
        <NextLink
          href="/review/"
          onClick={() => {
            customEvent({
              newGtm: {
                path: "parlor_detail_price",
                trigger_and_target: "price-tab_review",
              },
            });
          }}
        >
          <HStack justifyContent="center" alignItems="center">
            <Box className="orange650 subtitle_14_b" marginRight="3px">
              고이, 상주님들의 후기 보기
            </Box>
            <ColorIcon
              name="arrow_right_small"
              color={colors.orange650}
              width="12px"
              height="12px"
            />
          </HStack>
        </NextLink>

        <NextLink
          href="/funeral-prepare/1/"
          onClick={() => {
            customEvent({
              newGtm: {
                path: "parlor_detail_price",
                trigger_and_target: "uv_funeral_prepare_1",
              },
            });
          }}
        >
          <HStack justifyContent="center" alignItems="center">
            <Box className="orange650 subtitle_14_b" marginRight="3px">
              장례 준비가 처음이라면?
            </Box>
            <ColorIcon
              name="arrow_right_small"
              color={colors.orange650}
              width="12px"
              height="12px"
            />
          </HStack>
        </NextLink>
      </HStack>
    </DetailTitleRoot>
  );
}

const DetailTitleRoot = styled.div`
  padding: 6px 12px 12px;
  .subtitle2_b {
    white-space: nowrap;
  }
`;

export default DetailTitle;
